export enum EGeozoneQueryKey {
  GEOZONES = 'geozones'
}
